import { useQuery } from '@tanstack/react-query';

import { fetchEntitlements } from '@/features/billing/api/billing';

/**
 * Which features the merchant's plan grants, as yes/no.
 *
 * Shared by the sidebar and the route guards, so a feature the plan withholds
 * vanishes from the navigation and refuses at the address in one go. Until
 * the answer arrives - or if it never does - nothing is hidden: a slow or
 * failed billing call must not make a merchant's tools disappear, and the API
 * still refuses what the plan does not include.
 */
export function useEntitlements() {
  const query = useQuery({
    queryKey: ['subscription', 'entitlements'],
    queryFn: fetchEntitlements,
    staleTime: 60_000,
  });

  const granted = (feature: string | undefined): boolean => {
    if (!feature || !query.data) return true;
    return query.data[feature] !== false;
  };

  return { granted, loaded: query.isSuccess, entitlements: query.data ?? null };
}
